import React from 'react';
import PropTypes from 'prop-types';
import './employeeProfileHeader.scss';

const EmployeeProfileHeader = ({ employeeData, loading: __loading }) => {
  const {
    fullName = '-',
    employeeId = '-',
    vertical = '-',
    designation = '-',
    emailId = '-',
    department = '-',
  } = employeeData || {};

  return (
    <div className="employee-profile-header-container">
      {/* Box 1: Employee Name & Employee ID */}
      <div className="profile-info-box">
        <div className="info-row">
          <span className="info-label">Employee Name</span>
          <span className="info-value">{fullName}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Employee ID</span>
          <span className="info-value">{employeeId}</span>
        </div>
      </div>

      {/* Box 2: Employee Vertical & Designation */}
      <div className="profile-info-box">
        <div className="info-row">
          <span className="info-label">Employee Vertical</span>
          <span className="info-value">{vertical}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Employee Designation</span>
          <span className="info-value">{designation}</span>
        </div>
      </div>

      {/* Box 3: Employee Email & Department */}
      <div className="profile-info-box">
        <div className="info-row">
          <span className="info-label">Employee Email</span>
          <span className="info-value email-value" title={emailId}>{emailId}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Employee Department</span>
          <span className="info-value">{department}</span>
        </div>
      </div>
    </div>
  );
};

EmployeeProfileHeader.propTypes = {
  employeeData: PropTypes.shape({
    fullName: PropTypes.string,
    employeeId: PropTypes.string,
    vertical: PropTypes.string,
    designation: PropTypes.string,
    emailId: PropTypes.string,
    department: PropTypes.string,
  }),
  loading: PropTypes.bool,
};

EmployeeProfileHeader.defaultProps = {
  employeeData: {},
  loading: false,
};

export default EmployeeProfileHeader;
